/* tslint:disable */
/* eslint-disable */
/**
 * Calvin Risk API
 * TBD
 *
 * The version of the OpenAPI document: 6.0.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * Write serializer for creating custom field values.
 * @export
 * @interface CustomFieldValueCreate
 */
export interface CustomFieldValueCreate {
  /**
   *
   * @type {number}
   * @memberof CustomFieldValueCreate
   */
  field: number;
  /**
   *
   * @type {number}
   * @memberof CustomFieldValueCreate
   */
  useCase?: number | null;
  /**
   *
   * @type {number}
   * @memberof CustomFieldValueCreate
   */
  aiModel?: number | null;
  /**
   *
   * @type {string}
   * @memberof CustomFieldValueCreate
   */
  textValue?: string | null;
  /**
   *
   * @type {Blob}
   * @memberof CustomFieldValueCreate
   */
  fileValue?: Blob | null;
}

/**
 * Check if a given object implements the CustomFieldValueCreate interface.
 */
export function instanceOfCustomFieldValueCreate(value: object): value is CustomFieldValueCreate {
  if (!('field' in value) || value['field'] === undefined) return false;
  return true;
}

export function CustomFieldValueCreateFromJSON(json: any): CustomFieldValueCreate {
  return CustomFieldValueCreateFromJSONTyped(json, false);
}

export function CustomFieldValueCreateFromJSONTyped(json: any, ignoreDiscriminator: boolean): CustomFieldValueCreate {
  if (json == null) {
    return json;
  }
  return {
    field: json['field'],
    useCase: json['use_case'] == null ? undefined : json['use_case'],
    aiModel: json['ai_model'] == null ? undefined : json['ai_model'],
    textValue: json['text_value'] == null ? undefined : json['text_value'],
    fileValue: json['file_value'] == null ? undefined : json['file_value'],
  };
}

export function CustomFieldValueCreateToJSON(value?: CustomFieldValueCreate | null): any {
  if (value == null) {
    return value;
  }
  return {
    field: value['field'],
    use_case: value['useCase'],
    ai_model: value['aiModel'],
    text_value: value['textValue'],
    file_value: value['fileValue'],
  };
}
